import { headerClass, headerType, photoPosition, photoSide } from '@/types/uiPhoto.types'

export default function () {
  const { t } = useI18n()
  
  const uiPhotoData = () => {
    return {
      desktopHeaderClass: headerClass.H5,
      mobileHeaderClass: headerClass.H8,
      headingType: headerType.H3,
      headerTitle: t('wellbeingSale.forEmpoy.header'),
      desktopPhotoPosition: photoPosition.LEFT,
      photoDesktop: [{
        url: '/images/wellbeing-sale/wellbeing_score.png',
        public_id: '',
      }],
      photoMobile: [{
        url: '/images/wellbeing-sale/wellbeing_score.png',
        public_id: '',
      }],
      photoSide: photoSide.LEFT,
      descriptionSize: 'small',
      description: {
        content: [
          {
            nodeType: 'unordered-list',
            content: [
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.forEmpoy.list1'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.forEmpoy.list2'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.forEmpoy.list3'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.forEmpoy.list4'),
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    }
  }

  return {
    uiPhotoData,
  }
}
